module.exports = __webpack_public_path__ + "img/texture-2.f6006210.png";